import { TranslocoMissingHandler } from '@ngneat/transloco';
import { logger } from '@ts/shared/util-logging';

export class I18nMissingHandler implements TranslocoMissingHandler {
  handle(key: string /* , config: TranslocoConfig */) {
    logger.error(`Missing translation for key "${key}"`);
    return key;
  }
}
